/** Integrity / private-run copy — kept out of main locale files for LOC limit. */
export const integrityEn = {
  integrityHint: 'Private runs — god only. Open a signal to see who, when, and how before you classify or act.',
  integrityForbidden: 'Restricted to platform god.',
  integrityEmpty: 'No private run traces yet.',
  integrity_trace_clean: 'Clean run — no integrity signals.',
  integrity_trace_with_signals: 'Run completed · signals detected',
  integrity_kind_conspiracy: 'Conspiracy',
  integrity_kind_corruption: 'Corruption',
  integrity_kind_sabotage: 'Sabotage',
  integrity_lister_runner_collusion: 'Lister–runner collusion on house {houseId} ({roles}).',
  integrity_plays_after_collection: 'Plays inscribed after collection on house {houseId}.',
  integrity_collection_without_plays: 'Collection without recent plays on house {houseId}.',
  integrity_ledger_skew: 'Ledger skew on {house} ({ratio}% outflow).',
  integrity_suspended_house_activity: 'Activity on suspended house {houseId}: {action}.',
  integrity_config_tamper_burst: 'Repeated config changes on {houseId} ({count} events).',
  integrity_post_result_play: 'Play recorded after results on {houseId}.',
  integrityDispOpen: 'Open',
  integrityDispTp: 'True positive',
  integrityDispFp: 'False positive',
  integrityDispSuppressed: 'Suppressed',
  integrityDispSaved: 'Disposition saved',
  integrityDispHint: 'Mark how this signal should be treated. Suppressed / false positive stops new alerts for this house and code and clears matching inbox notifications until you set Open or True positive.',
  integrityDispSaving: 'Processing your request…',
  integrityDetails: 'Review details',
  integrityReviewHint: 'Review who acted, when, and the event log before you classify this signal.',
  integrityWho: 'Who',
  integrityWhen: 'When',
  integrityHouse: 'House',
  integrityRunAt: 'Scan',
  integrityTimeline: 'Triggering events',
  integrityRelatedAudit: 'Related audit',
  integrityMitigate: 'Mitigation',
  integrityGoHouse: 'Open house',
  integrityGoStaff: 'House staff',
  integrityGoTickets: 'House tickets',
  integrityGoAudit: 'Full audit log',
  integrityUnknownActor: 'Unattributed',
  integrityNoActor: 'No user attributed (ledger or system condition).',
  integrityUnknownWhen: 'Time not stored on this signal',
  integrityNoEvents: 'This run did not store an event log. Use related audit or open the full log.',
  integrityNoRelatedAudit: 'No extra audit events in the scan window.',
  integrityEventFallback: 'Recorded action',
  integrityMetricWindow: 'Detection window',
  integrityMetricLookback: 'Lookback',
  integrityMetricCount: 'Events in burst',
  integrityMetricCoinsIn: 'Coins in',
  integrityMetricCoinsOut: 'Coins out',
  integrityMetricRatio: 'Outflow',
  integrityMetricAction: 'Action',
} as const;

export const integrityEs = {
  integrityHint: 'Corridas privadas — solo god. Abre una señal para ver quién, cuándo y cómo antes de clasificarla o actuar.',
  integrityForbidden: 'Restringido al god de plataforma.',
  integrityEmpty: 'Aún no hay trazas de corridas privadas.',
  integrity_trace_clean: 'Corrida limpia — sin señales de integridad.',
  integrity_trace_with_signals: 'Corrida completada · señales detectadas',
  integrity_kind_conspiracy: 'Conspiración',
  integrity_kind_corruption: 'Corrupción',
  integrity_kind_sabotage: 'Sabotaje',
  integrity_lister_runner_collusion: 'Colusión lister–runner en banca {houseId} ({roles}).',
  integrity_plays_after_collection: 'Jugadas inscritas tras cobro en banca {houseId}.',
  integrity_collection_without_plays: 'Cobro sin jugadas recientes en banca {houseId}.',
  integrity_ledger_skew: 'Desvío de libro en {house} ({ratio}% salida).',
  integrity_suspended_house_activity: 'Actividad en banca suspendida {houseId}: {action}.',
  integrity_config_tamper_burst: 'Cambios de config repetidos en {houseId} ({count} eventos).',
  integrity_post_result_play: 'Jugada registrada tras resultados en {houseId}.',
  integrityDispOpen: 'Abierta',
  integrityDispTp: 'Verdadera',
  integrityDispFp: 'Falsa',
  integrityDispSuppressed: 'Suprimida',
  integrityDispSaved: 'Disposición guardada',
  integrityDispHint: 'Marca cómo tratar esta señal. Suprimida / falsa evita nuevas alertas de este código y casa y quita las notificaciones coincidentes de la bandeja hasta que pongas Abierta o Verdadera.',
  integrityDispSaving: 'Procesando su solicitud…',
  integrityDetails: 'Revisar detalles',
  integrityReviewHint: 'Revisa quién actuó, cuándo y el registro de eventos antes de clasificar esta señal.',
  integrityWho: 'Quién',
  integrityWhen: 'Cuándo',
  integrityHouse: 'Casa',
  integrityRunAt: 'Corrida',
  integrityTimeline: 'Eventos que dispararon la señal',
  integrityRelatedAudit: 'Auditoría relacionada',
  integrityMitigate: 'Mitigación',
  integrityGoHouse: 'Abrir casa',
  integrityGoStaff: 'Personal de la casa',
  integrityGoTickets: 'Tickets de la casa',
  integrityGoAudit: 'Auditoría completa',
  integrityUnknownActor: 'Sin atribuir',
  integrityNoActor: 'Sin usuario atribuido (condición de libro o del sistema).',
  integrityUnknownWhen: 'Esta señal no guarda la hora',
  integrityNoEvents: 'Esta corrida no guardó un registro de eventos. Usa la auditoría relacionada o abre el log completo.',
  integrityNoRelatedAudit: 'No hay eventos extra de auditoría en la ventana.',
  integrityEventFallback: 'Acción registrada',
  integrityMetricWindow: 'Ventana de detección',
  integrityMetricLookback: 'Retroceso',
  integrityMetricCount: 'Eventos en ráfaga',
  integrityMetricCoinsIn: 'Entrada',
  integrityMetricCoinsOut: 'Salida',
  integrityMetricRatio: 'Salida relativa',
  integrityMetricAction: 'Acción',
} as const;
